import { Injectable } from '@angular/core';
import { I18n } from '@aws-amplify/core';
import { TranslationEn } from '../../translation/translation.en';
import { TranslationEs } from '../../translation/translation.es';
import { TranslationFr } from '../../translation/translation.fr';
import { TranslationPt } from '../../translation/translation.pt';

export const TOKEN_USER = '_u';

@Injectable()
export class TranslatorService {

  dict = {
    es: TranslationEs.dict,
    pt: TranslationPt.dict,
    en: TranslationEn.dict,
    fr: TranslationFr.dict,
  };

  constructor() {
    I18n.putVocabularies(this.dict);
  }

  trans(stringToken: string): string {
    return I18n.get(stringToken);
  }

  getLanguage(): string {
    const user = JSON.parse(localStorage.getItem(TOKEN_USER));

    return user ? user.language : 'es';
  }

  setLanguage(language: string): void {
    if (language in this.dict) {

      I18n.setLanguage(language);
    } else {

      I18n.setLanguage('es');
    }
  }
}
